import { useContext } from "react";
import { UNSAFE_NavigationContext, useNavigate, useLocation } from "react-router-dom";
const ReactRouter6Adapter = ({
  children
}) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const navigate = useNavigate();
  const location = useLocation();
  const adapter = {
    replace(location2) {
      navigate(location2.search || "?", {
        replace: true,
        state: location2.state
      });
    },
    push(location2) {
      navigate(location2.search || "?", {
        replace: false,
        state: location2.state
      });
    },
    get location() {
      var _a;
      return (_a = navigator == null ? void 0 : navigator.location) != null ? _a : location;
    }
  };
  return children(adapter);
};
export {
  ReactRouter6Adapter
};
